module.exports = __webpack_public_path__ + "static/media/lloyd_hires.3a687421.jpg";